import { cn } from '../../lib/cn';
import { PayNowButton } from './PayNowButton';

interface StickyBottomBarProps {
  total: number;
  count: number;
  onPay: () => void;
  disabled?: boolean;
  extra?: React.ReactNode;
}

export function StickyBottomBar({
  total,
  count,
  onPay,
  disabled,
  extra,
}: StickyBottomBarProps) {
  return (
    <div
      className={cn(
        'border-t border-slate-100 bg-white p-4 pb-6 shadow-elevation-3 dark:border-slate-800 dark:bg-slate-800'
      )}
    >
      {extra}
      <PayNowButton total={total} count={count} onClick={onPay} disabled={disabled} />
    </div>
  );
}
